export class EntraRestoreReportJob {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantResourceId",
            "baseName": "tenantResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantDisplayName",
            "baseName": "tenantDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotPointInTime",
            "baseName": "snapshotPointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "initiatedBy",
            "baseName": "initiatedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "EntraRestoreReportJobStatusEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportJob.attributeTypeMap;
    }
    constructor() {
    }
}
export var EntraRestoreReportJobStatusEnum;
(function (EntraRestoreReportJobStatusEnum) {
    EntraRestoreReportJobStatusEnum["Completed"] = "COMPLETED";
    EntraRestoreReportJobStatusEnum["CompletedWithActionsRequired"] = "COMPLETED_WITH_ACTIONS_REQUIRED";
})(EntraRestoreReportJobStatusEnum || (EntraRestoreReportJobStatusEnum = {}));
